import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { APIURL } from "../../Global";
import { useAlert } from "react-alert";
import './nurseroster.css';

const NurseRosterTable = () => {
  const [nurses, setNurses] = useState([]);
  const [dates, setDates] = useState([]);
  const [rosterData, setRosterData] = useState([]);
  const navigate = useNavigate();
  const alert = useAlert();
  const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0]); // Default to today

  useEffect(() => {
    const tokenString = sessionStorage.getItem("usertoken");
    const token = tokenString?.replace(/["]+/g, ""); // Safely parse token

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    };

    // Fetch Nurse Details
    axios
      .get(`${APIURL}/api/v1/service-provider/nurse/`, { headers })
      .then((res) => {
        if (res.status === 200) {
          const filteredNurses = res.data.filter((nurse) => nurse.username);
          setNurses(filteredNurses);
        }
      })
      .catch(() => alert.error("Error fetching nurse data"));
  }, [])

  const fetchRoster = async (fromDate) => {
    const endDate = new Date(fromDate);
    endDate.setDate(endDate.getDate() + 28); // End date is 28 days from start date
    const formattedEndDate = endDate.toISOString().split("T")[0];

    const tokenString = sessionStorage.getItem("usertoken");
    const token = tokenString?.replace(/["]+/g, ""); // Safely parse token

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    };

    // Fetch Roster Data
    axios
      .get(`${APIURL}/api/v1/service-provider/nurse-roster/?start_date=${fromDate}&end_date=${formattedEndDate}`, { headers })
      .then((res) => {
        if (res.status === 200 && res.data.status === "success") {
          setRosterData(res.data.details || []);
        }
      })
      .catch(() => alert.error("Error fetching roster data"));

    const datesArray = [];
    let currentDate = new Date(fromDate);
    while (currentDate <= endDate) {
      datesArray.push(currentDate.toISOString().split("T")[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    setDates(datesArray);
  };


  useEffect(() => {
    fetchRoster(startDate);
  }, [startDate]);

  const getCellContent = (nurseId, date) => {
    const shift = rosterData.find(
      (item) => item.nurse === nurseId && item.date.split("T")[0] === date
    );
    if (shift && shift.status === "Leave") return { content: "L", style: { backgroundColor: "#f8d7da" } }; // Leave
    else if (shift && shift.status === "Off") return { content: "O", style: { backgroundColor: "#d1ecf1" } }; // Weekly Off
    return { content: shift && shift.shift_type, style: { backgroundColor: "#d4edda" } }; // Working Shift
  };

  const handleDateChange = (event) => {
    const newStartDate = event.target.value;
    setStartDate(newStartDate); // Update the start date
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <label style={{ marginRight: "10px", fontWeight: "bold" }}>
            Start Date:
          </label>
          <input
            type="date"
            value={startDate}
            onChange={handleDateChange}
            style={{
              padding: "5px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "16px",
            }}
          />
        </div>
        <div style={{ textAlign: "right", marginBottom: "20px" }}>
          <button
            onClick={() => navigate("/leave")}
            style={{
              margin: "10px",
              padding: "10px 20px",
              backgroundColor: "#2456AE",
              color: "white",
              border: "none",
              borderRadius: "5px",
              fontSize: "16px",
            }}
          >
            Manage Holidays
          </button>
          <button
            onClick={() => navigate("/roster")}
            style={{
              margin: "10px",
              padding: "10px 20px",
              backgroundColor: "#2456AE",
              color: "white",
              border: "none",
              borderRadius: "5px",
              fontSize: "16px",
            }}
          >
            Manage Roster
          </button>
        </div>
      </div>
      {rosterData.length > 0 ? (
        <table className="roster-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ccc", padding: "8px", backgroundColor: "#f5f5f5" }}>Nurse</th>
              {dates.map((date) => (
                <th key={date} style={{ border: "1px solid #ccc", padding: "8px", backgroundColor: "#f5f5f5" }}>
                  {date}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {nurses.map((nurse) => (
              <tr key={nurse.id}>
                <td style={{ border: "1px solid #ccc", padding: "8px", textTransform: "capitalize" }}>{nurse.name}</td>
                {dates.map((date) => {
                  const { content, style } = getCellContent(nurse.user, date);
                  return (
                    <td
                      key={date}
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        textAlign: "center",
                        textTransform: "capitalize",
                        ...style,
                      }}
                    >
                      {content}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <label className="no-data">No Prepared Roster Available!!</label>
      )}
    </div>
  );
};

export default NurseRosterTable;
